
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightAlarmColourOn as ObiLightAlarmColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-alarm-colour-on.js';
 
 
 

 
 export const ObiLightAlarmColourOn = createComponent({
   react: React,
   tagName: 'obi-light-alarm-colour-on',
   elementClass: ObiLightAlarmColourOnElement,
   events: {
     
   }
  });
 
 